import React from "react";
import research from './Assets/Research.svg';
import mediaProduction from './Assets/MediaProduction.svg';
import legalGovernment from './Assets/LegalGovernment.svg';
import corpGeneralBusiness from './Assets/CorpGeneralBusiness.svg';
import Noneoftheabove from './Assets/Noneoftheabove.svg';
import education from './Assets/Education.svg';
import { Vertical } from "../enums";

interface VerticalProps {
  verticalId: string;
  vertical: Vertical;
  setFieldIsEmpty: (isEmpty: boolean) => void;
  chosenVertical: string;
  updateVerticalChoice: (vertical: string) => void;
}

const VerticalOption = ({
                          verticalId,
                          vertical,
                          setFieldIsEmpty,
                          chosenVertical,
                          updateVerticalChoice
                        }: VerticalProps) => {
  var isChecked = verticalId === chosenVertical;

  const iconsMap: Record<Vertical, string> = {
    [Vertical.research]: research,
    [Vertical.media]: mediaProduction,
    [Vertical.legal]: legalGovernment,
    [Vertical.education]: education,
    [Vertical.corporate]: corpGeneralBusiness,
    [Vertical.other]: Noneoftheabove
  }

  const handleChange = () => {
    setFieldIsEmpty(false);
    updateVerticalChoice(verticalId);
    isChecked = true;
  };

  return (
    <div className={`verticalContainer ${isChecked ? "activeVertical" : ""}`} onClick={handleChange}>
      <div className="leftContent">
        <img src={iconsMap[vertical]} alt={vertical} className="IconVertical"/>
        <span className="verticalText">{vertical}</span>
      </div>

      <div className={`checkboxSquare ${isChecked ? "checked" : ""}`}>
        {isChecked && <span className="checkmark">✔</span>}
      </div>

      <input
        type="radio"
        name="vertical"
        value={verticalId}
        checked={isChecked}
        onChange={() => {
        }}
        style={{display: 'none'}}
      />
    </div>
  );
};

export default VerticalOption;
